import { Box } from '@mui/material';
import * as React from 'react';

import { TListBoxWrapperProps } from '@/shared/components/ui/form/components/searchable-select/components/list-box/components/list-box-wrapper/list-box-wrapper.types';

export const ListBoxWrapperContext = React.createContext({});

export const ListBoxWrapper: React.FC<TListBoxWrapperProps> = ({
  ref,
  style,
  ...props
}) => {
  const outerProps = React.useContext(ListBoxWrapperContext);

  // react-window sets `overflow: auto` inline, so an oversized option would add
  // a horizontal scrollbar that flickers as rows mount and unmount.
  return (
    <Box
      ref={ref}
      {...props}
      {...outerProps}
      style={{ ...style, overflowX: 'hidden' }}
    />
  );
};
